function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Group_9369"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_9365"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_8960"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 771",
  x: 0.3125,
  y: 36.5869,
  width: 144.029,
  height: 3.60073,
  rx: 1.80037,
  fill: "#3F3DB3"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 773",
  x: 0.3125,
  y: 36.5869,
  width: 68.4139,
  height: 3.60073,
  rx: 1.80037,
  fill: "#5A57FF"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_9366"
}, /*#__PURE__*/React.createElement("path", {
  id: "Polygon 7",
  d: "M79.9847 60.339C80.4134 60.5865 80.4134 61.2052 79.9847 61.4527L69.7587 67.3567C69.33 67.6042 68.7942 67.2948 68.7942 66.7998L68.7942 54.9918C68.7942 54.4968 69.33 54.1875 69.7587 54.435L79.9847 60.339Z",
  fill: "#9C9AFF"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_8961"
}, /*#__PURE__*/React.createElement("path", {
  id: "Polygon 8",
  d: "M105.453 60.3385C105.882 60.586 105.882 61.2047 105.453 61.4522L95.2274 67.3562C94.7988 67.6037 94.2629 67.2943 94.2629 66.7994L94.2629 54.9913C94.2629 54.4964 94.7988 54.187 95.2274 54.4345L105.453 60.3385Z",
  fill: "#4846CC"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 774",
  x: 105.262,
  y: 53.9497,
  width: 2.31524,
  height: 13.8915,
  rx: 1.15762,
  fill: "#4846CC"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_8962"
}, /*#__PURE__*/React.createElement("path", {
  id: "Polygon 8_2",
  d: "M40.242 61.4535C39.8133 61.206 39.8133 60.5873 40.242 60.3398L50.468 54.4358C50.8967 54.1883 51.4325 54.4977 51.4325 54.9926L51.4325 66.8007C51.4325 67.2956 50.8967 67.605 50.468 67.3575L40.242 61.4535Z",
  fill: "#4846CC"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 774_2",
  x: 40.4337,
  y: 67.8403,
  width: 2.31524,
  height: 13.8915,
  rx: 1.15762,
  transform: "rotate(-180 40.4337 67.8403)",
  fill: "#4846CC"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_9337"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M87.9629 0.976674C87.8031 0.591755 87.4972 0.285874 87.1123 0.126022C86.9229 0.0453034 86.7195 0.00248892 86.5137 0H78.6373C78.2195 0 77.8188 0.165967 77.5234 0.461389C77.228 0.756812 77.062 1.15749 77.062 1.57528C77.062 1.99307 77.228 2.39375 77.5234 2.68917C77.8188 2.98459 78.2195 3.15056 78.6373 3.15056H82.7173L73.9114 11.9564L68.7288 6.75795C68.5823 6.6103 68.4081 6.49311 68.2161 6.41314C68.0242 6.33316 67.8183 6.29199 67.6103 6.29199C67.4024 6.29199 67.1965 6.33316 67.0045 6.41314C66.8125 6.49311 66.6383 6.6103 66.4919 6.75795L57.0402 16.2096C56.8925 16.3561 56.7753 16.5303 56.6954 16.7223C56.6154 16.9142 56.5742 17.1201 56.5742 17.3281C56.5742 17.536 56.6154 17.7419 56.6954 17.9339C56.7753 18.1259 56.8925 18.3001 57.0402 18.4465C57.1866 18.5942 57.3609 18.7114 57.5528 18.7914C57.7448 18.8713 57.9507 18.9125 58.1586 18.9125C58.3666 18.9125 58.5725 18.8713 58.7644 18.7914C58.9564 18.7114 59.1306 18.5942 59.2771 18.4465L67.6103 10.0975L72.793 15.296C72.9394 15.4436 73.1137 15.5608 73.3056 15.6408C73.4976 15.7208 73.7035 15.7619 73.9114 15.7619C74.1194 15.7619 74.3253 15.7208 74.5173 15.6408C74.7092 15.5608 74.8834 15.4436 75.0299 15.296L84.9384 5.37171V9.45168C84.9384 9.86947 85.1044 10.2702 85.3998 10.5656C85.6952 10.861 86.0959 11.027 86.5137 11.027C86.9315 11.027 87.3322 10.861 87.6276 10.5656C87.923 10.2702 88.089 9.86947 88.089 9.45168V1.57528C88.0865 1.36943 88.0437 1.16606 87.9629 0.976674Z",
  fill: "#00D88A"
})));

function SvgPlayChartUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 69,
    viewBox: "0 0 145 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayChartUpIcon);
export default __webpack_public_path__ + "static/media/play-chart-up-icon.c813185d8777041f002aa452f157306b.svg";
export { ForwardRef as ReactComponent };